export enum CRONJOB_STATUS {
  RUNNING = 'running',
  STOPPED = 'stopped',
};
